import {Table, useSortableTable} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {StaticPartLayerTypes} from '@refra/modules/refra-static-parts/enums'

interface ShutdownDetailInfoTableRow {
  layer: StaticPartLayerTypes
  material: string
  thickness?: number | string
  weight: number | string
  cost?: number | string
}

interface ShutdownDetailInfoTableProps {
  rows: ShutdownDetailInfoTableRow[]
}

export const ShutdownDetailInfoTable = ({rows}: ShutdownDetailInfoTableProps) => {
  const {t} = useTranslation()

  const config = useSortableTable<ShutdownDetailInfoTableRow>([
    {
      label: t('staticParts.editReplacement.table.layer'),
      render: (row) => (
        <div className="flex items-center gap-2">
          <span>{t(`staticParts.editReplacement.layers.${row.layer}`)}</span>
        </div>
      )
    },
    {
      label: t('staticParts.editReplacement.table.material'),
      value: (row) => row?.material ?? '-'
    },
    {
      label: t('staticParts.editReplacement.table.thickness'),
      value: (row) => row?.thickness ?? '-'
    },
    {
      label: t('staticParts.editReplacement.table.materialPlanned'),
      value: (row) => row.weight ?? '-'
    },
    {
      label: `${t('staticParts.editReplacement.table.cost')} ($)`,
      value: (row) => row?.cost ?? '-'
    }
  ])

  return <Table config={config} data={rows} />
}
